import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Registration} from "../../models/registration";
import {Service} from "../../models/service";
import Helpers from "../../utils/helpers";

@Injectable()
export class RegistrationControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getAllRegistrations(): Observable<Registration[]> {
    return this.http.get(this.baseUrl + "registration") as  Observable<Registration[]>;
  }

  public getRegistrationsList(serviceId: string): Observable<Registration[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/registration") as  Observable<Registration[]>;
  }

  public getRegistration(id: string): Observable<Registration> {
    return this.http.get(this.baseUrl + "registration/" + id) as Observable<Registration>;
  }

  public getRegistrationField(serviceId: string, fieldKey: string): Observable<Registration> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/registration/field/" + fieldKey) as Observable<Registration>;
  }

  public createRegistration(registration: Registration): Observable<Registration> {
    Helpers.trimRecursiveObj(registration);
    const body = JSON.stringify(registration);
    return this.http.post(this.baseUrl + "registration", body) as  Observable<Registration>;
  }

  public saveRegistration(serviceId: string, registration: Registration) {
    Helpers.trimRecursiveObj(registration);
    const body = JSON.stringify(registration);
    return this.http.put(this.baseUrl + "service/" + serviceId  + "/registration", body, {responseType: "text"});
  }

  public deleteRegistration(registrationId: string) {
    return this.http.delete(this.baseUrl + "registration/" + registrationId, {responseType: "text"});
  }

  public updateSortOrder(registrations: Registration[]) {
    Helpers.trimRecursiveObj(registrations);
    const body = JSON.stringify(registrations);
    return this.http.put(this.baseUrl + "sortregistrations", body, {responseType: "text"});
  }

  public saveRegistrations(serviceId: string, registrations: Registration[]): Observable<Registration[]> {
    Helpers.trimRecursiveObj(registrations);
    const body = JSON.stringify(registrations);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/registrations", body) as Observable<Registration[]>;
  }

  public saveRegistrationsAndDeterminants(serviceId: string, catalogueId: string): Observable<Registration[]> {
      return this.http.get(this.baseUrl + "service/" + serviceId + "/registrationscatalogues/" + catalogueId) as Observable<Registration[]>;
  }

  public addRegistrationToService(serviceId: string, registrationId: string): Observable<Service> {
    return this.http.post(this.baseUrl + "service_registration/" + serviceId + "/" + registrationId, {responseType: "text"}) as  Observable<Service>;
  }

  public removeRegistrationFromService(serviceId: string, registrationId: string) {
    return this.http.delete(this.baseUrl + "service_registration/" + serviceId + "/" + registrationId, {responseType: "text"});
  }

}
